import {Table, Tag} from 'antd';
import '../../pages/customerDashboard/styles.scss';
import {CommonAxiosSuccessResponseDto} from "../../dto/CommonAxiosSuccessResponseDto";
import ErrorHandler from "../../util/ErrorHandler";
import customerService from "../../service/customerService";
import {useEffect, useState} from "react";
import dayjs from "dayjs";
import {NOT_AVAILABLE, YYYY_MM_DD_HH_MM} from "../../util/Constants";

interface PropType {
    cinNumber: string
}

interface PendingChangeReq {
    requestId: number
    requestType: string
    createdDate: any
    recordStatus: string
}

const PendingChangeRequest = (props: PropType) => {
    const [tableData, setTableData] = useState<PendingChangeReq[]>([])
    const [isLoading, setLoading] = useState(false)


    const columns = [
        {
            title: 'Request Id',
            dataIndex: 'requestId',
            key: 'requestId'
        },
        {
            title: 'Request Type',
            dataIndex: 'requestType',
            key: 'requestType',
            align: "center",
            sorter: (a: any, b: any) => {
                a = a.requestType == null ? '' : a.requestType
                b = b.requestType == null ? '' : b.requestType
                return a.localeCompare(b);
            },
            render: (text: any) => (
                getTypeNameByType(text)
            )
        },
        {
            title: 'Request Date',
            dataIndex: 'createdDate',
            key: 'createdDate',
            sorter: (a: any, b: any) => {
                a = a.createdDate == null ? '' : a.createdDate
                b = b.createdDate == null ? '' : b.createdDate
                return a.localeCompare(b);
            },
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },

    ];

    const getTypeNameByType = (type: string) => {

        switch (type) {
            case "ADDRESS CHANGE":
                return <Tag bordered={false} color='gold'>Address</Tag>
            case "CONTACT DETAILS CHANGE":
                return <Tag bordered={false} color='magenta'>Contact Details</Tag>
            case "BANK DETAILS CHANGE":
                return <Tag bordered={false} color='blue'>Bank Details</Tag>
            case "SIGNATURE CHANGE":
                return <Tag bordered={false} color='purple'>Signature</Tag>
        }
    }
    useEffect(() => {
        if (undefined != props.cinNumber && "" != props.cinNumber) {
            setLoading(true)
            customerService.getPendingChangeRequestList(props.cinNumber).then(
                (res: CommonAxiosSuccessResponseDto<PendingChangeReq[]>) => {

                    setTableData(res.data.results);
                    setLoading(false)
                }).catch((res) => {
                ErrorHandler.handleError(res)
                setLoading(false)
            })
        }

    }, [props.cinNumber])

    return (
        <>
            {/*maximum table rows 7 per 1 page */}
            <Table dataSource={tableData} columns={columns} pagination={{pageSize: 7}} loading={isLoading}/>
        </>
    );
};

export default PendingChangeRequest;
